import { useCallback } from "react";
import { Account } from "../../../types";
import { useAccountData } from "../../../hooks/useAccountData";
import { appStore } from "../../../hookstate/appStore";
import { rootComponentsStore } from "../../../hookstate/rootComponentsStore";

export function useMixpanelRecorder() {
  const accountDataCache = useAccountData();

  const loadMixpanel = (accountData: Account) => {
    if (accountData?.features["mixpanel_session_recording"]) {
      if (!rootComponentsStore.mixpanelInitialized.get()) {
        window.loadMixpanel();
        const mixpanel_project_id = appStore.init.mixpanel_project_id.get();
        mixpanel.init(mixpanel_project_id, {
          // @ts-expect-error typings are not up to date
          record_min_ms: 5000,
          disable_persistence: true,
          record_block_selector: "",
          record_mask_text_selector: "",
          record_heatmap_data: true
        });
        rootComponentsStore.mixpanelInitialized.set(true);
      }

      const userData = accountData?.user;
      if (userData) {
        window.mixpanel.identify(userData.id.toString());
      } else {
        // this sdk doesn't allow identifying as a $device:id guest, so we have to use register instead
        window.mixpanel.register({
          distinct_id: "$device:" + accountData.guest_id,
          $device_id: accountData.guest_id,
        });
      }
    }
  };

  const recordMixpanel = useCallback(
    async (accountData?: Account) => {
      accountData = accountData || accountDataCache;
      if (!accountData) return;
      if (!accountData.features["mixpanel_session_recording"]) return;

      // Wait for mixpanel to initialize if it hasn't
      if (!rootComponentsStore.mixpanelInitialized.get()) {
        loadMixpanel(accountData);
        await new Promise((resolve) => {
          setTimeout(resolve, 500);
        });
      }

      try {
        // @ts-expect-error typings are not up to date
        window.mixpanel.start_session_recording();
      } catch (err) {
        /* no big deal */
      }
    },
    [accountDataCache],
  );

  return recordMixpanel;
}
